var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-helmet/es/Helmet'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/react-helmet/es/Helmet.js' implicitly has an 'any' type.
import { Helmet } from "react-helmet/es/Helmet";
import React from "react";
import useService from "../../Hooks/useService";
import useCachedLoadSEOInfo from "../../Hooks/useCachedLoadSEOInfo";
import InstitutionService from "../../../Services/Institution.service";
// @ts-expect-error - TS7006 - Parameter 'title' implicitly has an 'any' type.
const defaultMakeTitle = (title) => __awaiter(void 0, void 0, void 0, function* () {
    const institutionTitle = yield InstitutionService.getApplicationTitle();
    return title ? `${title} - ` + institutionTitle : institutionTitle;
});
export const SEOTitleContext = React.createContext({
    makeTitle: defaultMakeTitle,
});
export const SEOTitleContextProvider = ({ children, makeTitle, }) => (_jsx(SEOTitleContext.Provider, { value: { makeTitle: makeTitle || defaultMakeTitle }, children: children }));
const SEO = ({ title }) => {
    const { makeTitle } = React.useContext(SEOTitleContext);
    const [seoInfo, loadSeoInfo] = useService(useCachedLoadSEOInfo());
    const [applicationTitle, loadApplicationTitle] = useService(InstitutionService.getApplicationTitle);
    React.useEffect(() => {
        loadSeoInfo();
        loadApplicationTitle();
    }, [loadApplicationTitle, loadSeoInfo]);
    const [titleString, getTitle] = useService(makeTitle);
    React.useEffect(() => {
        if (seoInfo.data) {
            getTitle(title, seoInfo.data);
        }
    }, [getTitle, seoInfo.data, title, titleString.data]);
    return (_jsx(Helmet, { children: _jsx("title", { children: titleString.data ||
                applicationTitle.data ||
                "Watermark Student Success & Engagement" }) }));
};
export default SEO;
